export default "__VITE_ASSET__CvYmkBcb__"